var React = require('react');

function Map (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"currentColor","fill":"none","d":"M7.5 18V3.7M14 15.7 7.5 18 1 15.7V1l6.5 2.7","key":0}),React.createElement("path",{"stroke":"currentColor","fill":"none","d":"m14 15.7 7 2.3V3.7L14 1 7.5 3.7M14 15.9V1.2","key":1})]);
}

Map.defaultProps = {"version":"1.1","x":"0","y":"0","viewBox":"0 0 22 19","style":{"enableBackground":"new 0 0 22 19"}};

module.exports = Map;

Map.default = Map;
